import { render, staticRenderFns } from "./surplusFlow.vue?vue&type=template&id=f9f1c968&scoped=true"
import script from "./surplusFlow.vue?vue&type=script&lang=js"
export * from "./surplusFlow.vue?vue&type=script&lang=js"
import style0 from "./surplusFlow.vue?vue&type=style&index=0&id=f9f1c968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f1c968",
  null
  
)

export default component.exports